// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33COW","delete":"styles_delete__deHvp","update":"styles_update__1Qzzk","add":"styles_add__1b2Yw"};